import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "@/store/modules/auth";
import queryLog from "@/store/modules/queryLog";
import supervision from "@/store/modules/supervision";
import users from "@/store/modules/users";

export default createStore({
	state: {},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		auth,
		users,
		supervision,
		queryLog,
	},
	plugins: [
		createPersistedState({
			// Auth is reconstructed on every bootstrap from the refresh_token
			// cookie. Persisting state.auth.token kept isAuthenticated truthy
			// on reload while the in-memory access token was empty, so API
			// calls fired without Bearer headers and the 401 forced logout.
			reducer: ({ auth: _auth, ...rest }) => rest,
		}),
	],
});
